interface IEmptying {
  weekNumber: number;
  yearNumber: number;
}

export function nameOfEmptying(emptying: IEmptying, t: any) {
  return `${t ? t("general.CW") : "KW"} ${emptying.weekNumber} - ${emptying.yearNumber}`
}
